module.exports = __webpack_public_path__ + "b305773b5134fd9117bfc5c195b7862e.png";